import React, { useEffect } from 'react';

import { MediaTrackingContext } from '@tracker/mediaTracking/contexts/MediaTrackingContext';
import { getMediaTrackingHandler } from '@tracker/mediaTracking/mediaTrackingHandler';
import {
  MediaTrackingEventComponentLevelData,
  MediaTrackingSource,
} from '@tracker/mediaTracking/mediaTrackingModel';

import { crl8 } from 'app/curalate.globals';

interface IProps {
  source: MediaTrackingSource;
  children: React.ReactNode;
}

export const MediaTrackingContextProvider = ({ source, children }: IProps) => {
  const mediaTrackingHandler = getMediaTrackingHandler(source);

  // Send all currently queued events if provider is unmounted or the window is unloaded
  useEffect(() => {
    const onPageUnload = () => mediaTrackingHandler.dispatchImmediately();

    window.addEventListener('beforeunload', onPageUnload);
    return () => {
      window.removeEventListener('beforeunload', onPageUnload);
      onPageUnload();
    };
  }, [mediaTrackingHandler]);

  return (
    <MediaTrackingContext.Provider
      value={{
        isTrackingEnabled: crl8.isMediaTrackingEnabled,
        source: source,
        trackEvent: (eventData: MediaTrackingEventComponentLevelData) =>
          mediaTrackingHandler.track(eventData),
      }}
    >
      {children}
    </MediaTrackingContext.Provider>
  );
};
